import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { LoggerService } from './logger.service';
import { SessionResponse } from '../_models/session-response';
import { Observable } from 'rxjs';
import { SessionRequest } from '../_models/session-request';

@Injectable({
  providedIn: 'root'
})
export class SessionService extends BaseService {

  private readonly serviceUrl: string = this.baseUrl + '/session/';

  constructor(
    private http: HttpClient,
    private router: Router,
    private logger: LoggerService
  ) {
    super(router, logger);
  }

  getSessionResponse(request: SessionRequest): Observable<SessionResponse> {
    return this.http.post<SessionResponse>(this.serviceUrl + 'getSessionResponse', request);
  }

  public getNzaToken(): Observable<string> {
    return this.http.get<string>(this.serviceUrl + 'getNZAToken');
  }
}
